import styled from '@emotion/styled';
import { borderRadius, breakpoints, spacing } from '@naf/theme';
import { Link } from '@naf-simba/elements-links';
import { Text } from '@naf/text';

export const Wrapper = styled.div`
  display: grid;
  grid-template-areas: 'mapbutton hitcount' 'filter hitlist';
  grid-template-columns: 1fr 5fr;
  grid-gap: ${spacing.space32};
  grid-template-rows: auto auto;
  padding: ${spacing.space32} 0;

  @media (max-width: ${breakpoints.s}) {
    grid-template-areas: 'mapbutton' 'filter' 'hitcount' 'hitlist';
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
  }
`;

export const MapWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${spacing.space32} 0;
`;

export const MapButton = styled(Link)`
  grid-area: mapbutton;
  margin-left: ${spacing.space8};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Filter = styled.div`
  grid-area: filter;
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: ${spacing.space8};
  }
`;

export const FilterHeader = styled(Text)`
  margin: 0 0 ${spacing.space8} 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;
  user-select: none;
  padding: ${spacing.space8} 0;

  &:hover {
    opacity: 0.7;
  }
`;

export const AccordionIcon = styled.span`
  display: flex;
  align-items: center;
`;

export const ResultHeader = styled(FilterHeader)`
  text-transform: uppercase;
  margin: 0;
`;

export const BorderWrapper = styled.div`
  border-bottom: 1px solid #e6e6e6;
  padding: ${spacing.space24} 0;
`;

export const HitList = styled.div`
  grid-area: hitlist;
  display: flex;
  flex-direction: column;
  grid-gap: ${spacing.space24};
`;

export const LocationButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing.space8};
  padding: 6px ${spacing.space12};
  background-color: #f2f2f2;
  border: none;
  border-radius: ${borderRadius.ROUND};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: ${spacing.space16};
  transition: background-color 0.2s ease;
  width: fit-content;

  &:hover:not(:disabled) {
    background-color: #e6e6e6;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const LocationButtonWrapper = styled.div``;
